class SmartCaptchaFormValidator {
  constructor() {
    this.forms = document.querySelectorAll('form#has-captcha');
    this.init();
  }

  init() {
    this.loadWidget();
    this.forms.forEach((form) => {
      if (form.querySelector("#captcha-container")) {
        const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitBtn) {
          submitBtn.addEventListener("click", this.handleClick.bind(this), { capture: true });
        } else {
          form.addEventListener("submit", this.handleSubmit.bind(this), { capture: true });
        }
      }
    });
  }

  loadWidget() {
    const container = document.getElementById("captcha-container");
    if (!container) return;

    const sitekey = container.getAttribute("data-sitekey");
    if (!sitekey) return;

    const showLoadError = () => {
      container.innerHTML = `
        <div class="captcha-error" role="alert">
          <p>Не удалось загрузить капчу.</p>
          <button type="button" class="btn btn-sm btn-outline-secondary captcha-retry">
            Повторить попытку
          </button>
        </div>
      `;
      container.querySelector(".captcha-retry")?.addEventListener("click", () => {
        container.innerHTML = '<div class="captcha-placeholder__spinner"></div>';
        this.loadWidget();
      });
    };

    window.smartCaptchaInit = () => {
      if (window.smartCaptcha) {
        const widgetId = window.smartCaptcha.render("captcha-container", {
          sitekey,
          hl: "ru",
        });
        if (widgetId) {
          window.smartCaptcha.subscribe(widgetId, "network-error", showLoadError);
          window.smartCaptcha.subscribe(widgetId, "javascript-error", showLoadError);
        }
      }
    };

    const script = document.createElement("script");
    script.src =
      "https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=smartCaptchaInit";
    script.defer = true;
    script.onerror = showLoadError;
    document.head.appendChild(script);

    setTimeout(() => {
      if (!container.querySelector('[name="smart-token"]') && !container.querySelector(".captcha-error")) {
        if (!container.querySelector("iframe")) {
          showLoadError();
        }
      }
    }, 15000);
  }

  handleClick(event) {
    const form = event.target.closest("form");
    const token = form?.querySelector('[name="smart-token"]')?.value;

    if (!token) {
      event.preventDefault();
      event.stopImmediatePropagation();
      alert("Сначала подтвердите, что вы человек.");
      return false;
    }
  }

  handleSubmit(event) {
    const form = event.target;
    const token = form.querySelector('[name="smart-token"]')?.value;

    if (!token) {
      event.preventDefault();
      event.stopImmediatePropagation();
      alert("Сначала подтвердите, что вы человек.");
      return false;
    }
  }
}

export default SmartCaptchaFormValidator;
